
import Vue from "vue";
import { SaleEditState } from "@/utils/sale-edit/sale-edit-state";
import { Bank, BankType, Contact , Sale} from "@/models/base";
import { BankService } from "@/services/bank-service";
import { DossierConfigService } from "@/services/dossier-config-service";
import { CustomerService } from "@/services/customer-service";
import { BankKind } from "@/models/base/bank";
import { CashDro } from "@/plugins/cashdro/cashdro";
import AppCashDroModal from "./CashDroModal.vue";
import { AuthService } from "@/services/auth-service";
import { MODULE } from "@/config/modules";
import { ElectronCtep } from "@/utils/electron/electron-ctep";
import { CtepEctError } from "@/utils/ctep/ctep-ect-error";
import { v4 } from "uuid";
import {SaleService, UserConfigService} from "@/services";
import {CashierService} from "@/services/cashier-service";
import AppSendMessageDialog from "@/components/mail/SendMessageDialog.vue";
import { Deposit } from "@/models/base/deposit";
import { TranslateResult } from "vue-i18n";
import { roundToDecimals } from "@/utils/numbers";
import { CtepService } from "@/services/ctep-service";
import { CtepSettings } from "@/utils/ctep/ctep-settings";
import { ICtepService } from "@/utils/ctep/ctep-service";
import AppCtepTerminalSelect from "@/components/common/CtepTerminalSelect.vue";
import { CtepSaleResult } from "@/utils/ctep/ctep-sale-result";
import AppMollieTerminalSelect from "@/components/common/MollieTerminalSelect.vue";
import { MollieTerminalService } from "@/services/mollie-terminal-service";
import { MollieTerminalSettings } from "@/utils/mollie-terminal/mollie-terminal-settings";
import { MollieTerminalPayment } from "@/utils/mollie-terminal/mollie-terminal";

export default Vue.extend({
	data() {
		return {
			payedAmounts: [] as number[],
			ctepAmount: 0,
			bankTypes: [] as BankType[],
			selectedBank: 0,
			bank: new Bank(),
			showCashDroModal: false,
			showCashDroScreen: false,
			cashDroFailed: false,
			cashDroScreenUrl: CashDro.getScreenUrl(),
			cashDroAmount: 0,
			cashDroOperation: "",
			isCtepPaymentBusy: false,
			buttonsDisabled: false,
			ConnectedDisplay: "",
			ctepSendModalOpenedResolve: null as null | Function,
			ctepSendModalOpenedReject: null as null | Function,
			ctepToSendFile: null as null | File,
			selectedCtepTerminal: "",
			ctepCancelPressed: false,
			mollieAmount: 0,
			isMolliePaymentBusy: false,
			selectedMollieTerminal: "",
			currentMolliePaymentId: "",
			mollieChangeStateUrl: ""
		};
	},
	props: {
		state: {
			type: Object as () => SaleEditState,
			required: true
		},
		isDeposit: Boolean
	},
	computed: {
		hasPendingPayments():boolean{
			for (let i = 0; i < this.bankTypeItems.length; i++) {
				if (this.payedAmounts[i] !== 0) {
					return true;
				}
			}
			if (this.ctepAmount != 0){
				return true;
			}
			if (this.mollieAmount != 0){
				return true;
			}
			if (this.cashDroAmount != 0) {
				return true;
			}
			return false;
		},
		to():string {
			if (!this.sale.InvoiceAddress) {
				return "";
			}
			return this.sale.InvoiceAddress.Email;
		},
		locale(): string {
			return this.$i18n.locale;
		},
		MODULE() {
			return MODULE;
		},
		totalPayed(){
			let t = 0;
			this.payedAmounts.forEach((v)=> t+=v);
			t += this.ctepAmount;
			t += this.mollieAmount;
			return t;
		},
		toRefund(): number {
			if (this.amountNotRounded - this.amountRounded == roundToDecimals(this.sale.TotalToPay - this.totalPayed, 2)) {
				return 0;
			}
			return (this.totalPayed > this.sale.TotalToPay) ? roundToDecimals(this.totalPayed - this.sale.TotalToPay, 2) : 0;
		},
		leftToPay(): number {
			//if ((this.amountNotRounded - (this.amountRounded + this.leftToPay)) == this.sale.TotalToPay - this.totalPayed) {
			if(this.amountNotRounded == 0 && (this.sale.TotalToPay - this.totalPayed) < 0.03 ){
				return 0;
			}
			return (this.totalPayed < this.sale.TotalToPay) ? roundToDecimals(this.sale.TotalToPay - this.totalPayed, 2) : 0;
		},
		amountRounded(): number {
			let a = (Math.round(this.sale.TotalOpen / 0.05) * 0.05 ) - this.totalPayed;
			return Math.abs(a) < 0.03 ? 0 : a;
		},
		amountNotRounded(): number {
			//let a = this.amountRounded != this.sale.TotalToPay ? this.sale.TotalToPay - this.totalPayed : 0;
			let a = this.sale.TotalOpen - this.totalPayed;
			return Math.abs(a) < 0.03 ? 0 : roundToDecimals(a, 2);
		},
		showPaymentDifferenceCash(): boolean {
			let rounded = roundToDecimals(this.paymentDifferenceCash, 2);
			return rounded >= 0.01 && rounded < 0.03;
		},
		paymentDifferenceCash(): number {
			let diff = roundToDecimals(Math.abs(this.sale.TotalOpen - this.totalPayed), 2);
			return diff < 0.01 ? 0 : diff;
		},
		bankTypeItems(): BankType[] {
			return this.bankTypes.filter(t => {
				if (t.ShowOnCashierDisplay) {
					return t;
				}
			});
		},
		selectedDeposit():Deposit | null {
			if (!this.isDeposit) return null;
			return this.state.createdDepositsData.deposits[this.state.createdDepositsData.deposits.length-1] || null;
		},
		sale():Sale{
			if (this.isDeposit && this.selectedDeposit) {
				return this.selectedDeposit.Sale || this.state.sale;
			}
			return this.state.sale;
		},
		title():TranslateResult {
			if (this.isDeposit){
				return this.$ct("title-deposit");
			}
			return this.$ct("title");
		},
		ctepSettings():CtepSettings {
			return CtepService.getSettings();
		},
		ctepEnabled():boolean {
			if (!AuthService.hasModule(MODULE.KOPPELING_MET_BANCONTACT)) return false;
			if (this.ctepSettings.mode == "off") return false;
			return true;
		},
		showCtepTerminalSelect():boolean {
			if (!this.ctepEnabled) return false;
			return CtepService.getSettings().mode == "cloud";
		},
		ctepService():ICtepService | null{
			if (!this.ctepEnabled) return null;
			if (this.showCtepTerminalSelect){
				return CtepService.createService(this.selectedCtepTerminal);
			}
			return ElectronCtep;
		},
		mollieTerminalSettings():MollieTerminalSettings {
			return MollieTerminalService.getSettings();
		},
		mollieTerminalEnabled():boolean {
			if (!MollieTerminalService.hasModule()) return false;
			if (!this.mollieTerminalSettings.enabled) return false;
			return DossierConfigService.getMollieConfig().ConnectedWithMollie;
		},
		showMollieTerminalSelect():boolean {
			if (!this.mollieTerminalEnabled) return false;
			return !this.mollieTerminalSettings.defaultTerminalId;
		}
	},
	watch: {
		showCtepTerminalSelect: {
			immediate: true,
			handler(){
				if (!this.showCtepTerminalSelect) return;
				this.selectedCtepTerminal = this.ctepSettings.defaultTerminalId;
			}
		}
	},
	methods: {
		showOnDisplay(){
			CashierService.openDisplay(this.ConnectedDisplay,this.sale.ID);
		},
		focusSelectedBank(){
			const index = this.bankTypeItems.findIndex(b => b.ID == this.selectedBank);
			if (index < 0) return;
			const inputs = this.$refs.bankInput as any;
			const input = Array.isArray(inputs) ? inputs[index] : inputs;
			if (input && typeof input.focus === "function") {
				input.focus();
			}
		},
		hasModule(moduleId:number):boolean{
			return AuthService.hasModule(moduleId);
		},
		openSendModal() {
			this.state.openSendModal();
		},
		cancel(){
			if (this.buttonsDisabled) return;
			this.state.ticketRefundModalOpen = false;
			this.$emit("update");
		},
		setTotalPayed(amount: number, bank: number) {
			if (amount == 0){
				this.$set(this.payedAmounts, bank, 0.0);
			}else{
				this.$set(this.payedAmounts, bank, this.payedAmounts[bank]+amount);
			}
		},
		async cashdro(){
			if(this.cashDroAmount == 0){
				this.$wf.notify(this.$ct("amount-zero").toString(), "danger", 3000, "exclamation-triangle");
				return;
			}
			let c = await CashDro.test();
			if(c.code != 1){
				this.$wf.notify(this.$ct("components.settings-plugin.AppCashDro.not-connected").toString(), "danger", 3000, "exclamation-triangle");
			}
			this.cashDroAmount = roundToDecimals(Math.round(this.cashDroAmount / 0.05) * 0.05, 2);
			c = await CashDro.start(this.cashDroAmount);
			if(c.code != 1){
				let message = this.$ct("components.settings-plugin.AppCashDro.not-connected").toString();
				if(CashDro.isDirect() && c.data){
					message = c.data == "Operation not queued" ? this.$ct("components.settings-plugin.AppCashDro.busy").toString() : `CashDro: ${c.data}`;
				}
				this.$wf.notify(message, "danger", 5000, "exclamation-triangle");
				this.cashDroFailed = true;
			}else{
				this.cashDroFailed = false;
				this.cashDroOperation = c.data;
				this.showCashDroModal = true;
			}
		},
		setTotalPayedCtep(){
			if (this.amountNotRounded == 0.00){
				this.ctepAmount = 0;
			}else{
				this.ctepAmount += this.amountNotRounded;
			}
		},
		async onCashDroSucces(actualPayed: number){
			this.showCashDroModal = false;
			if(actualPayed > 0){
				let bank = new Bank();
				let typeId = DossierConfigService.getGeneralConfig().DefaultCashPaymentBankTypeID || 9;
				bank.Total = actualPayed;
				bank.InvoiceID = this.sale.ID;
				bank.Contact = await CustomerService.getContact(this.sale.ContactID);
				bank.ContactID = this.sale.ContactID;
				bank.FriendlySaleID = this.sale.ComputedFriendlyID;
				bank.BookYear = this.sale.BookYear;
				bank.Kind = BankKind.Sale;
				bank.TypeID = typeId;
				await BankService.postBooking(bank);
				this.$wf.notify(this.$ct("common.success").toString(), "success", 3000, "check");
				this.cashDroAmount = 0;
				await this.refreshSale();
				let difference = roundToDecimals(this.sale.TotalOpen - this.totalPayed, 2);
				if(difference != 0 && Math.abs(difference) < 0.03){
					await this.payCreateDifferenceBank(difference);
					await this.refreshSale();
				}
			}
			if(this.sale.TotalOpen == 0.0){
				this.$emit("update");
			}
		},
		async refreshSale(){
			let sale = await SaleService.getSale(this.sale.ID);
			if (!this.isDeposit){
				if (!this.state.ticketRefundModalOpen) return;
				this.state.sale = sale;
			}else if (this.selectedDeposit) {
				this.selectedDeposit.Sale = sale;
			}
		},
		payCreateBank(bankTypeId:number, amount:number, contact:Contact){
			let bank = new Bank();
			bank.Total = amount;
			bank.InvoiceID = this.sale.ID;
			bank.Contact = contact;
			bank.ContactID = this.sale.ContactID;
			bank.FriendlySaleID = this.sale.ComputedFriendlyID;
			bank.BookYear = this.sale.BookYear;
			bank.Kind = BankKind.Sale;
			bank.TypeID = bankTypeId;
			bank.TimeCreated = this.bank.TimeCreated;
			return bank;
		},
		handleCtepError(err:any){
			this.isCtepPaymentBusy = false;
			if (typeof(err) == "object" && (err as any).getErrorMessage){
				let error = err as CtepEctError;
				this.$wf.dialog(error.getErrorMessage(), this.$ct("common.ok"), this.$ct("common.error"), "warning");
			}else{
				this.$wf.dialog(this.$ct("ctep-transaction-uncertain"), this.$ct("common.ok"), this.$ct("common.error"), "warning");
			}
			throw err;
		},
		async sendCtepResult(bank:Bank){
			this.ctepToSendFile = (await BankService.downloadCtepTicketAsPdf(bank)) as any as File;
			(this.ctepToSendFile as any).name = "ctep-result.pdf";
			try{
				await new Promise((resolve, reject)=>{
					this.ctepSendModalOpenedReject = reject;
					this.ctepSendModalOpenedResolve = resolve;
				});
			}catch(err){
				throw err;
			}finally{
				this.ctepSendModalOpenedReject = null;
				this.ctepSendModalOpenedResolve = null;
				this.ctepToSendFile = null;
			}
		},
		async onCtepResult(contact:Contact, result:CtepSaleResult, ctepSettings:CtepSettings){
			if (result.signatureRequired){
				await this.$wf.dialog(this.$ct("ctep-signature-required"), this.$ct("common.ok"), this.$ct("common.warning"), "warning");
			}
			this.$wf.notify(this.$ct("ctep-payment-successfull"), "success", 3000, "exclamation-triangle");
			this.isCtepPaymentBusy = false;
			let bankConfig = DossierConfigService.getBankConfig();
			let bank = this.payCreateBank(bankConfig.getBankIdByCtepBrandID(result.cardBrandIdentifier) || ctepSettings.defaultBankId, result.authorizedAmount, contact);
			bank.CtepSaleResult = result.toModel();
			bank = await BankService.postBooking(bank);
			if (ctepSettings.openSendTicketAfterPaid){
				this.sendCtepResult(bank);
			}
			this.ctepAmount = 0;
		},
		async payCtep(contact:Contact):Promise<void>{
			let ctepSettings = CtepService.getSettings();
			if (this.ctepAmount == 0) return;
			if (ctepSettings.mode == "off") return;
			if (this.ctepAmount < 0) {
				await this.notifyNegativeAmountIsNotValidForCtep();
				return;
			}
			if (!this.ctepService) return;
			try{
				this.isCtepPaymentBusy = true;
				this.ctepCancelPressed = false;
				let result = await this.ctepService.sendSaleTransaction(this.ctepAmount, `${this.sale.ComputedFriendlyID}-${v4()}`);
				if (this.ctepCancelPressed) {
					await this.$wf.dialog(this.$ct("ctep-cancelation-failed"), this.$ct("common.ok"), this.$ct("common.error"), "warning");
				}
				await this.onCtepResult(contact, result, ctepSettings);
			}catch(err){
				this.handleCtepError(err);
				throw err;
			} finally{
				this.isCtepPaymentBusy = false;
			}
		},
		async useCtepLastTransaction(){
			let ctepSettings = CtepService.getSettings();
			if (ctepSettings.mode == "off") return;
			if (!this.ctepService) return;
			let contact =  await CustomerService.getContact(this.sale.ContactID);
			try{
				this.isCtepPaymentBusy = true;
				this.ctepCancelPressed = false;
				let result = await this.ctepService.lastTransaction();
				let isForThisSale = new RegExp(`^Ref.:\\s*\\n${this.sale.ComputedFriendlyID}-`, "m").test(result.clientTicket);
				if (!isForThisSale){
					let text = this.$ct("warning-last-transaction-is-not-for-this-ticket");
					let confirm = await this.$confirmBuilder(text).setWarningTitle().show();
					if (!confirm) return;
				}
				await this.onCtepResult(contact, result, ctepSettings);
			}catch(err){
				this.handleCtepError(err);
				throw err;
			} finally{
				this.isCtepPaymentBusy = false;
			}
		},
		async cancelCtepPayment(){
			if (!this.ctepService) return;
			try{
				this.ctepCancelPressed = true;
				await this.ctepService.cancelSale();
			}catch(err){
				this.handleCtepError(err);
				throw err;
			}
		},
		setTotalPayedMollie(){
			if (this.amountNotRounded == 0.00){
				this.mollieAmount = 0;
			}else{
				this.mollieAmount += this.amountNotRounded;
			}
		},
		async onMollieResult(contact:Contact, payment:MollieTerminalPayment){
			this.$wf.notify(this.$ct("mollie-payment-successfull"), "success", 3000, "check");
			let mollieConfig = DossierConfigService.getMollieConfig();
			let bankTypeId = mollieConfig.getBankTypeIdForTerminal(this.selectedMollieTerminal) || mollieConfig.BankID;
			let bank = this.payCreateBank(bankTypeId, payment.Amount, contact);
			bank.Info = `Mollie payment ID: ${payment.ID}`;
			await BankService.postBooking(bank);
			this.mollieAmount = 0;
		},
		async payMollie(contact:Contact):Promise<void>{
			if (!this.mollieTerminalEnabled) return;
			if (this.mollieAmount == 0) return;
			if (this.mollieAmount < 0) {
				let message = this.$ct("ticket-refund-negative-amount-is-not-valid-for-mollie");
				await this.$wf.dialog(message, this.$ct("common.ok"), this.$ct("common.error"), "warning");
				return;
			}
			this.isMolliePaymentBusy = true;
			try{
				let payment = await MollieTerminalService.createPayment(this.mollieAmount, this.selectedMollieTerminal, this.sale.ComputedFriendlyID);
				this.currentMolliePaymentId = payment.ID;
				this.mollieChangeStateUrl = payment.ChangePaymentStateURL;
				payment = await MollieTerminalService.waitForFinalStatus(payment);
				if (payment.Status != "paid") {
					let message = this.$ct(`mollie-payment-${payment.Status}`).toString();
					if (payment.StatusReasonMessage) {
						message += `\n${payment.StatusReasonMessage}`;
					}
					await this.$wf.dialog(message, this.$ct("common.ok"), this.$ct("common.error"), "warning");
					throw new Error(`Mollie payment ${payment.Status}`);
				}
				await this.onMollieResult(contact, payment);
			}finally{
				this.isMolliePaymentBusy = false;
				this.currentMolliePaymentId = "";
				this.mollieChangeStateUrl = "";
			}
		},
		async cancelMolliePayment(){
			if (!this.currentMolliePaymentId) return;
			try{
				await MollieTerminalService.cancelPayment(this.currentMolliePaymentId);
			}catch(err){
				this.$wf.notify(this.$ct("mollie-cancelation-failed").toString(), "danger", 3000, "exclamation-triangle");
			}
		},
		openMollieChangeState(){
			window.open(this.mollieChangeStateUrl, "_blank");
		},
		async payCreateDifferenceBank(total?: number){
			let bank = new Bank();
			let bID = DossierConfigService.getGeneralConfig().DefaultPaymentDifferenceBankTypeID;
			let bCode = DossierConfigService.getGeneralConfig().DefaultCashRoundingLedgerAccountCode;
			//Todo plus of min?
			bank.Total = total ?? roundToDecimals(this.sale.TotalToPay - this.totalPayed, 2);
			bank.InvoiceID = this.sale.ID;
			bank.Contact = await CustomerService.getContact(this.sale.ContactID);
			bank.ContactID = this.sale.ContactID;
			bank.FriendlySaleID = this.sale.ComputedFriendlyID;
			bank.BookYear = this.sale.BookYear;
			if(this.sale.TypeID==1||this.sale.TypeID==2||this.sale.TypeID==9) {
				bank.Kind = BankKind.Sale;
			}else{
				bank.Kind = BankKind.Diverse;
			}
			bank.TypeID = bID;
			bank.LedgerAccountCode = bCode;
			bank.TimeCreated = this.bank.TimeCreated;
			bank.Info = this.bank.Info;
			await BankService.postBooking(bank);
		},
		async payToRefundBank(){
			let bank = new Bank();
			//Todo plus of min?
			bank.Total = roundToDecimals(this.sale.TotalToPay - this.totalPayed, 2);
			bank.TotalDC = roundToDecimals(this.sale.TotalToPay - this.totalPayed, 2);
			bank.InvoiceID = this.sale.ID;
			bank.Contact = await CustomerService.getContact(this.sale.ContactID);
			bank.ContactID = this.sale.ContactID;
			bank.FriendlySaleID = this.sale.ComputedFriendlyID;
			bank.BookYear = this.sale.BookYear;
			if(this.sale.TypeID==1||this.sale.TypeID==2||this.sale.TypeID==9){
				bank.Kind = BankKind.Sale;
			}else{
				bank.Kind = BankKind.Diverse;
			}
			bank.TypeID = this.selectedBank;
			bank.TimeCreated = this.bank.TimeCreated;
			bank.Info = this.$ct("ticket-refund").toString() + this.sale.ComputedFriendlyID;
			await BankService.postBooking(bank);
		},
		async notifyNegativeAmountIsNotValidForCtep(){
			let message = this.$ct("ticket-refund-negative-amount-is-not-valid-for-ctep");
			await this.$wf.dialog(message, this.$ct("common.ok"), this.$ct("common.error"), "warning");
		},
		async checkIfAmountIsValid():Promise<boolean>{
			let i = 0;
			// eslint-disable-next-line @typescript-eslint/no-unused-vars
			let ctepSettings = CtepService.getSettings();
			if(ctepSettings.mode == "off"){
				return true;
			}
			for (const b of this.bankTypeItems) {
				if(this.payedAmounts[i] < 0){
					if (ctepSettings.defaultBankId == b.ID) {
						await this.notifyNegativeAmountIsNotValidForCtep();
						return false;
					}
				}
				i++;
			};
			return true;
		},
		async pay() {
			this.buttonsDisabled = true;
			try{
				if (!this.hasPendingPayments){
					this.$emit("update");
					return;
				}
				let i = 0;
				let contact =  await CustomerService.getContact(this.sale.ContactID);
				await this.payCtep(contact);
				await this.payMollie(contact);
				for (const b of this.bankTypeItems) {
					if(this.payedAmounts[i] != 0){
						let bank = this.payCreateBank(b.ID, this.payedAmounts[i], contact);
						bank = await BankService.postBooking(bank);
					}
					i++;
				};
				if(this.paymentDifferenceCash > 0 && this.paymentDifferenceCash < 0.03){
					await this.payCreateDifferenceBank();
				} else if(this.toRefund != 0 && this.totalPayed !== 0){
					await this.payToRefundBank();
				}
				this.payedAmounts = this.payedAmounts.map(() => 0);
			}finally{
				this.buttonsDisabled = false;
				await this.refreshSale();
			}
			if (!this.state.ticketRefundModalOpen) return;
			if (this.sale.TotalOpen == 0.0){
				if(this.ConnectedDisplay){
					CashierService.clearDisplay(this.ConnectedDisplay);
				}
				this.$emit("update");
			}
		},
		onCtepSent(){
			if (this.ctepSendModalOpenedResolve){
				this.ctepSendModalOpenedResolve();
			}
		},
		onCtepSendClose(){
			if (this.ctepSendModalOpenedReject) {
				this.ctepSendModalOpenedReject();
			}
		},

	},
	async created() {
		this.selectedMollieTerminal = this.mollieTerminalSettings.defaultTerminalId;
		this.bankTypes = await BankService.getTypes();
		this.selectedBank = DossierConfigService.getGeneralConfig().DefaultCashPaymentBankTypeID;
		this.payedAmounts = this.bankTypeItems.map(i => 0);
		this.$nextTick(() => this.focusSelectedBank());
		let c = await UserConfigService.getCashierSettings();
		this.ConnectedDisplay = c.ConnectedDisplay;
		if (CashDro.getConfiguration().host != "") {
			this.cashDroAmount = roundToDecimals(this.amountRounded, 2);
		}
	},
	components: {
		AppCashDroModal,
		AppSendMessageDialog,
		AppCtepTerminalSelect,
		AppMollieTerminalSelect
	},
	i18nEx: {
		componentPrefix: "components.sales.CashierRefund"
	},
});
